// src/stammdatenConfig.js

export const config = {
  ftr_cikk: {
    title: "Cikkek",
    api: {
       list: 'https://bogir.hu/V2/api/stammdaten/list.php',
      save: 'https://bogir.hu/V2/api/stammdaten/update.php'
     
    },
    fields: [
      { key: "az", label: "ID", readonly: true, visible: false },
      { key: "cikk_az", label: "Cikk AZ",  default: "0", readonly: true, visible: false },
      { key: "cikk_megn", label: "Megnevezés" , visible: true },
      { key: "cikk_egyseg", label: "Egység" , visible: true },
      { key: "cikk_cegaz", label: "Cég AZ", readonly: true, default: (store) => store.state.userData.ceg_az, visible: false },
      { key: "cikk_tisztAZ", label: "Tisztítás kiválaszt" ,options: [ { value: "1", label: "SÖPRÉS" }, { value: "2", label: "MOSÁS IVÓVÍZ MINŐSÉGŰ MAGAS NYOMÁSÚ VÍZZEL" },{ value: "3", label: "MOSÁS ZSÍROLDÓSZERREL" },{ value: "4", label: "FERTŐTLENÍTÉS" } ] , visible: true }, 
      { key: "tiszt_h", label: "Tiszt H",readonly:true , visible: true }, 
      { key: "tiszt_a", label: "Tiszt A" ,readonly:true , visible: true }, 
      { key: "cikk_idtf", label: "IDTF" , visible: true },
      { key: "cikk_felh", label: "Felhasználó", readonly:true, default: (store) => store.state.userData.nev, visible: false},
      { key: "cikk_dry", label: "Száraz", options: [ { value: "0", label: "Nem" }, { value: "-1", label: "Igen" } ] , visible: true },
      { key: "cikk_wet", label: "Nedves" , options: [ { value: "0", label: "Nem" }, { value: "-1", label: "Igen" } ] , visible: true },
      { key: "cikk_chem", label: "Vegyi", options: [ { value: "0", label: "Nem" }, { value: "-1", label: "Igen" } ] , visible: true },
      { key: "cikk_azOld", label: "Régi AZ", default: "0", readonly:true, visible: false }
    ]
  },

// 🔽 NEU: ftr_tav - Távolság
  ftr_tav: {
    title: "Távolság",
    api: {
      list: 'https://bogir.hu/V2/api/stammdaten/list.php',
      save: 'https://bogir.hu/V2/api/stammdaten/update.php'
    },
    fields: [
      { key: "az", label: "ID", readonly: true, visible: false },
      { key: "tav_az", label: "Távolság AZ", default: "0", readonly: true , visible: false},
      { key: "tav_megn", label: "Megnevezés", visible: true },
      { key: "tav_cegaz", label: "Cég AZ", readonly: true, default: (store) => store.state.userData.ceg_az , visible: false},
      { key: "tav_felh", label: "Felhasználó", readonly: true, default: (store) => store.state.userData.nev , visible: false},
      { key: "tav_azOld", label: "Régi AZ", default: "0", readonly: true , visible: false}
    ]
  },


 ftr_hely: {
    title: "Helyek",
    api: {
      list: 'https://bogir.hu/V2/api/stammdaten/list.php',
      save: 'https://bogir.hu/V2/api/stammdaten/update.php'
    },
    fields: [
      { key: "az", label: "ID", readonly: true , visible: false},
      { key: "hely_az", label: "Hely AZ", default: "0", readonly: true , visible: false},
      { key: "hely_tavaz", label: "Távolság AZ", default: "0", readonly:true , visible: false},
      { key: "tav_megn", label: "Távolság" , visible: true},
      { key: "hely_ceg", label: "Cég megnevezése" , visible: true},
      { key: "hely_cim", label: "Címe" , visible: true},
      { key: "hely_megj", label: "Megjegyzés" , visible: true},
      { key: "hely_cegaz", label: "Cég AZ", readonly: true, default: (store) => store.state.userData.ceg_az , visible: false},
      { key: "gps", label: "GPS koordináta" , visible: true},
      { key: "idokapu", label: "Időkapu" , visible: true},
      { key: "billenes", label: "Billenés" , visible: true},
      { key: "magassag", label: "Magasságkorlát" , visible: true},
      { key: "hely_azOld", label: "Régi AZ", default: "0", readonly: true , visible: false},
      { key: "cloud_chg", label: "Cloud CHG", readonly: true, default: "-1", visible: false }
    ]
  },


// 🔽 NEU: ftr_fuvarozo - Fuvarozók
ftr_fuvarozo: {
  title: "Fuvarozók",
  api: {
    list: 'https://bogir.hu/V2/api/stammdaten/list.php',
    save: 'https://bogir.hu/V2/api/stammdaten/update.php'
  },
  fields: [
    { key: "az", label: "ID", readonly: true, visible: false },
    { key: "f_kod", label: "Kód", visible: false },
    { key: "f_nev", label: "Megnevezés", visible: true },
    { key: "f_varos", label: "Város", visible: true },
    { key: "f_szem", label: "Kapcsolattartó", visible: true },
    { key: "f_cegaz", label: "Cég AZ", readonly: true, default: (store) => store.state.userData.ceg_az, visible: false },
    { key: "f_kodOld", label: "Régi kód", default: "0", readonly: true, visible: false }
  ]
}, 


//  utvonal
 utvonal: {
    title: "Útvonalak",
    api: {
      list: 'https://bogir.hu/V2/api/stammdaten/list.php',
      save: 'https://bogir.hu/V2/api/stammdaten/update.php'
    },
    fields: [
      // reine ID in WEB-DB
      { key: "az", label: "ID", readonly: true, visible: false },

      // VIR-Route-ID (lokales System)
      { key: "vir_az", label: "VIR az", readonly: true, visible: true },

      // Firma
      { 
        key: "ceg_az", 
        label: "Cég AZ", 
        readonly: true, 
        default: (store) => store.state.userData.ceg_az,
        visible: false
      },

      // Felrakó / Lerakó + Orte
      { key: "felrako",    label: "Felrakó", visible: true },
      { key: "lerako",     label: "Lerakó",  visible: true },
      { key: "fhely",      label: "Felrakó hely", visible: true },
      { key: "lhely",      label: "Lerakó hely",  visible: true },

      // Google-MyMaps Link
      { key: "utvonal",    label: "Google útvonal link", visible: false },

      // GPS Fel / Le (vorerst nur anzeigen, nicht editieren)
      { key: "fel_gps",    label: "Felrakó GPS", readonly: false, visible: true },
      { key: "le_gps",     label: "Lerakó GPS",  readonly: false, visible: true },

      // Typ, Distanz, Kommentar
      { key: "tipus",      label: "Típus",     visible: false },
      { key: "tavolsag",   label: "Távolság (km)", visible: true },
      { key: "megjegyzes", label: "Megjegyzés",    visible: false },

      // Prüfinfos (nur anzeigen)
      { key: "ellenorizte",       label: "Ellenőrizte",      readonly: true, visible: true },
      { key: "ellenorizte_datum", label: "Ellenőrzés dátuma", readonly: true, visible: true },

      // KMZ-Status (falls du sehen willst, sonst visible: false)
      { key: "kmz", label: "KMZ", visible: false, default: 0 }
    ]
  },




};
